import { useState, useContext } from 'react';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { shark, white } from '@ifit/base-coat/js/colors';
import { Listbox } from '@headlessui/react';
import { Text } from './text';
import cn from 'classnames';
import InfoPanel from './info-panel';
import { useMilestoneCount } from '../../state-management/server-state/use-milestone-count';
import { useUserType } from '../../state-management/selectors/use-user-type';
import DotsLoading from '@ifit/mp-dots-loading';
import Icon from '@ifit/react-icons/dist/components/icon';
import CHEVRON_DOWN_LINE from '@ifit/react-icons/dist/icons/CHEVRON_DOWN_LINE';
import { useMilestone } from '../../state-management/server-state/use-milestone';
import TrophyCase from './trophy-case';
import './index.scss';

export default function Achievements(): JSX.Element {
  const { theme } = useContext(ThemeContext);
  const isAnonymous = useUserType() === 'anonymous';
  const { isFetching: milestoneIsFetching } = useMilestone();

  const timeframes = [];
  for (let i = new Date().getFullYear(); i >= 2019; i--) {
    const year = i.toString();
    timeframes.push({
      value: i,
      name: Text.milestones(year),
      info: i === new Date().getFullYear() ? Text.infoCurrentYear : Text.infoPreviousYear(year),
    });
  }

  const themeColors = {
    LIGHT: {
      color: shark,
    },
    DARK: {
      color: white,
    },
    VAULT: {
      color: shark,
    },
  };

  const [timeframe, setTimeframe] = useState(timeframes[0]);
  const { isFetching, data, isSuccess } = useMilestoneCount(timeframe.value);
  const workoutCount = !isAnonymous ? data?.countYTD : 0;

  return (
    <div className="achievements">
      <div className="achievements-header">
        <Listbox value={timeframe} onChange={setTimeframe}>
          <Listbox.Button className="mp-user-stats-selector">
            <span>{timeframe.name}</span>
            <Icon icon={CHEVRON_DOWN_LINE} size={24} color={themeColors[theme].color} />
          </Listbox.Button>

          <Listbox.Options className="mp-user-stats-options">
            {timeframes.map((time) => (
              <Listbox.Option key={time.value} value={time} className="mp-user-stats-option no-min-width">
                {time.value}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>

        {(isFetching || milestoneIsFetching) && (
          <DotsLoading className="dots-loading" color={themeColors[theme].color} size={4} />
        )}

        <InfoPanel info={timeframe.info} />
      </div>

      <div className="achievements-main">
        <div className="achievements-count">
          <h3
            className={cn('achievements-count-title', {
              small: Text.workouts.length > 8,
            })}
          >
            {Text.workouts}
          </h3>

          <span className="achievements-workout-count">{workoutCount}</span>
        </div>

        {isSuccess && <TrophyCase workoutCount={workoutCount} year={timeframe.value} />}
      </div>
    </div>
  );
}
